import { FC } from 'react';
import type { DashboardTotals, KpiLens } from '../forecasting.types';
import { FORECASTING_THEME } from '../forecastingTheme';
import { formatCurrency, formatPercent } from '../utils/forecastingAggregations';
import { KpiCard, KpiGroup, KpiGroupTitle, KpiRow } from '../Forecasting.styles';

interface KpiScorecardsProps {
  totals: DashboardTotals;
  activeLens: KpiLens;
  onSelect: (lens: KpiLens) => void;
}

export const KpiScorecards: FC<KpiScorecardsProps> = ({ totals, activeLens, onSelect }) => (
  <KpiRow>
    <KpiGroup>
      <KpiGroupTitle>Dynamic Forecast</KpiGroupTitle>
      <KpiCard
        type="button"
        $border={FORECASTING_THEME.kpiDynamicBorder}
        $active={activeLens === 'dynamicForecastRevenue'}
        onClick={() => onSelect('dynamicForecastRevenue')}
      >
        <div className="label">Revenue</div>
        <div className="value">{formatCurrency(totals.dynamicRevenue)}</div>
      </KpiCard>
      <KpiCard
        type="button"
        $border={FORECASTING_THEME.kpiDynamicBorder}
        $active={activeLens === 'dynamicForecastGp'}
        onClick={() => onSelect('dynamicForecastGp')}
      >
        <div className="label">Gross Profit</div>
        <div className="value">{formatCurrency(totals.dynamicGp)}</div>
      </KpiCard>
    </KpiGroup>

    <KpiGroup>
      <KpiGroupTitle>Budget</KpiGroupTitle>
      <KpiCard
        type="button"
        $border={FORECASTING_THEME.kpiBudgetBorder}
        $active={activeLens === 'budgetRevenue'}
        onClick={() => onSelect('budgetRevenue')}
      >
        <div className="label">Revenue</div>
        <div className="value">
          {totals.budgetRevenue != null ? formatCurrency(totals.budgetRevenue) : '—'}
        </div>
      </KpiCard>
      <KpiCard
        type="button"
        $border={FORECASTING_THEME.kpiBudgetBorder}
        $active={activeLens === 'budgetGp'}
        onClick={() => onSelect('budgetGp')}
      >
        <div className="label">Gross Profit</div>
        <div className="value">{totals.budgetGp != null ? formatCurrency(totals.budgetGp) : '—'}</div>
      </KpiCard>
    </KpiGroup>

    <KpiGroup>
      <KpiGroupTitle>vs Budget</KpiGroupTitle>
      <KpiCard
        type="button"
        $border={FORECASTING_THEME.kpiVsBorder}
        $active={activeLens === 'vsBudgetRevenue'}
        onClick={() => onSelect('vsBudgetRevenue')}
      >
        <div className="label">Revenue</div>
        <div className="value">
          {totals.vsBudgetRevenuePct != null ? formatPercent(totals.vsBudgetRevenuePct, 0) : '—'}
        </div>
      </KpiCard>
      <KpiCard
        type="button"
        $border={FORECASTING_THEME.kpiVsBorder}
        $active={activeLens === 'vsBudgetGp'}
        onClick={() => onSelect('vsBudgetGp')}
      >
        <div className="label">Gross Profit</div>
        <div className="value">
          {totals.vsBudgetGpPct != null ? formatPercent(totals.vsBudgetGpPct, 0) : '—'}
        </div>
      </KpiCard>
    </KpiGroup>
  </KpiRow>
);
